import React from "react";

const Navbar4IconButton = ({
  children,
  onClick,
  title,
  badge = 0,
  active = false,
  className = "",
}) => {
  const hasBadge = Number(badge) > 0;

  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      aria-label={title}
      className={`relative inline-flex h-10 w-10 items-center justify-center rounded-2xl border text-sm transition-all duration-200 active:scale-95 ${
        active
          ? "border-slate-950 bg-slate-950 text-white shadow-md dark:border-white dark:bg-white dark:text-slate-950"
          : "border-slate-200 bg-white text-slate-700 shadow-sm hover:-translate-y-0.5 hover:border-slate-300 hover:shadow-md dark:border-white/10 dark:bg-white/[0.07] dark:text-white dark:hover:bg-white/[0.12]"
      } ${className}`}
    >
      {children}

      {hasBadge && (
        <span className="absolute -right-1.5 -top-1.5 flex min-w-[19px] items-center justify-center rounded-full bg-red-600 px-1.5 py-0.5 text-[10px] font-bold text-white ring-2 ring-white dark:ring-slate-950">
          {badge > 99 ? "99+" : badge}
        </span>
      )}
    </button>
  );
};

export default Navbar4IconButton;